import React from 'react';
import FinishLineRow from './FinishLineRow';
import { ScrollPanel } from 'primereact/scrollpanel';

export default function SB_MessageBox() {

    const finishline = [

    ];

    return (
        <div className="h-full rounded-xl bg-gray-100 flex flex-col">
            <div className="h-8 rounded-xl bg-sky-600 text-center content-center text-white">
                <i className="pi pi-send m-2" />
                <h2 className=' text-xl font-bold inline-block'>MESSAGES</h2>

            </div>
            <div className="flex-1">
                <ScrollPanel className="custombar1 p-2" style={{ height: "100% " }}>
                    <div className="grid rounded-xl h-full gap-2 absolute inset-x-0 top-0">
                        {finishline.map((fl) => (
                            <FinishLineRow key={fl.id + 200} result={fl} />
                        ))}
                    </div>
                </ScrollPanel>
            </div>
        </div>
    )
}